import { SearchModality } from '@aibees/elephant/feature/search-table-company/hooks/types';
import { createContext, useContext } from 'react';
import { TableActionContextData as ContextData } from './types';

// `effectiveModality` is defaulted rather than left to the `{}` cast: consumers
// read it as a required SearchModality, and an undefined value reads as "no
// modality" — which zeroes the credit-type flags and empties the enrichment
// list instead of failing loudly. TOTAL matches the fallback useSearchModality
// has always guaranteed.
const context = createContext<ContextData>({
  effectiveModality: SearchModality.TOTAL,
} as ContextData);

export const { Provider } = context;

export const useTableActionContext = () => useContext(context);
